import { RadioButton } from '../RadioButton';
import { Group } from './RadioGroup.styles';
import type { RadioGroupProps } from './RadioGroup.types';

export function RadioGroup({
  name,
  options,
  value,
  onChange,
  direction = 'row',
  hasError,
  variant = 'default',
}: RadioGroupProps) {
  return (
    <Group
      role="radiogroup"
      $direction={direction}
      $variant={variant}
      aria-invalid={hasError || undefined}
      tabIndex={hasError ? -1 : undefined}
    >
      {options.map((option) => (
        <RadioButton
          key={option.value}
          name={name}
          value={option.value}
          label={option.label}
          description={option.description}
          checked={value === option.value}
          onChange={onChange}
          disabled={option.disabled}
          variant={variant}
        />
      ))}
    </Group>
  );
}
